/**
 * The backend refuses to hand out an export whose redactions changed after
 * it was made (409 with this code; tasks/export-stale.ts). Anonymize again.
 */
export const EXPORT_OUTDATED = 'EXPORT_OUTDATED';

export function isExportOutdatedError(error: unknown): boolean {
  const e = error as { status?: number; data?: { code?: string } } | null;
  return e?.status === 409 && e?.data?.code === EXPORT_OUTDATED;
}
